import { render } from "./PatientDetailsOverlay.vue?vue&type=template&id=60b53dfd&scoped=true&lang=pug"
import script from "./PatientDetailsOverlay.vue?vue&type=script&lang=js"
export * from "./PatientDetailsOverlay.vue?vue&type=script&lang=js"

import "./PatientDetailsOverlay.vue?vue&type=style&index=0&id=60b53dfd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b53dfd"]])

export default __exports__